import React, { useState } from "react";
import HistoryModalDataAccordion from "../../../RpmModule/Components/HistoryModalDataAccordion";

const ConsultationHistoryModalContent = () => {
  //Constants..................................................
  const dummyConsultationDetails = {
    appointmentId: 1,
    appointmentDate: "2023-08-10",
    patientName: "John Doe",
    otherdocuments: {
      NurseNote: "https://example.com/nursenote.pdf",
      Diagonisis: "https://example.com/diagnosis.pdf",
      LabTest: "https://example.com/labtest.pdf",
      SpecialInstruction: "https://example.com/specialinstruction.pdf",
      Consent: "https://example.com/consent.pdf",
      Invoice: "https://example.com/invoice.pdf",
    },
    prescriptionsDetails: {
      medicine: "https://example.com/prescription.pdf",
      PrivateNote: "https://example.com/privatenote.pdf",
    },
    reportDetails: [
      {
        filename: "Report1.pdf",
        filecontent: "https://example.com/report1.pdf",
      },
      {
        filename: "Report2.pdf",
        filecontent: "https://example.com/report2.pdf",
      },
    ],
  };

  //Hooks......................................................
  const [ConsultationDetails] = useState(dummyConsultationDetails);

  //Functions...................................................
  let getDataFromVitals = (itemName, extension, ifEmpty) => {
    if (ConsultationDetails && ConsultationDetails[itemName]) {
      if (extension) {
        return ConsultationDetails[itemName] + extension;
      } else {
        return ConsultationDetails[itemName];
      }
    } else if (ifEmpty) {
      return ifEmpty;
    } else {
      return "";
    }
  };
  let handleOpenUrl = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="ahmc-container">
      <span className={`ahmc-container_header`}>
        Appointment ID - {getDataFromVitals("appointmentId")}
      </span>

      <div className="appointment-timeline">
        <div className="step">
          {/* <div className="step-graph">

                      <div className="round">&nbsp;</div>
                      <div className="length">&nbsp;</div>

                  </div> */}

          <div className="step-text">
            <div className="date">{getDataFromVitals("appointmentDate")}</div>

            <div className="step-text_row">
              For -{" "}
              <div className="date" style={{ marginLeft: "5px" }}>
                {" "}
                {getDataFromVitals("patientName")}
              </div>
            </div>

            {ConsultationDetails?.otherdocuments?.NurseNote ? (
              <HistoryModalDataAccordion
                data={ConsultationDetails.Nursenote}
                type="Nurse Note"
                fileurl={ConsultationDetails?.otherdocuments.NurseNote}
                key="0"
              />
            ) : (
              ""
            )}
            {ConsultationDetails?.otherdocuments?.Diagonisis ? (
              <HistoryModalDataAccordion
                data={ConsultationDetails.Diaganosis}
                type="Diagnosis"
                fileurl={ConsultationDetails?.otherdocuments?.Diagonisis}
                key="1"
              />
            ) : (
              ""
            )}
            {ConsultationDetails?.prescriptionsDetails?.medicine ? (
              <HistoryModalDataAccordion
                data={JSON.stringify(ConsultationDetails.Medicinelist)}
                type="Prescription"
                fileurl={ConsultationDetails?.prescriptionsDetails?.medicine}
                key="3"
              />
            ) : (
              ""
            )}
            {ConsultationDetails?.otherdocuments?.LabTest ? (
              <HistoryModalDataAccordion
                data={JSON.stringify(ConsultationDetails?.labtest)}
                type="Services"
                fileurl={ConsultationDetails?.otherdocuments.LabTest}
                key="4"
              />
            ) : (
              ""
            )}

            {ConsultationDetails?.prescriptionsDetails?.PrivateNote ? (
              <HistoryModalDataAccordion
                data={ConsultationDetails.privateNotes}
                type="Doctor Notes"
                fileurl={ConsultationDetails?.prescriptionsDetails?.PrivateNote}
                key="5"
              />
            ) : (
              ""
            )}

            <div className="step-end">&nbsp;</div>
          </div>
        </div>

        <div className="step">
          <div className="step-text">
            {ConsultationDetails?.otherdocuments?.Consent ? (
              <div className="step-text_row">Other documents</div>
            ) : (
              ""
            )}

            <ul>
              {ConsultationDetails?.otherdocuments?.Consent ? (
                <li
                  onClick={() => {
                    handleOpenUrl(ConsultationDetails?.otherdocuments.Consent);
                  }}
                >
                  Patient Consent Form
                </li>
              ) : (
                ""
              )}

              {ConsultationDetails?.otherdocuments?.Invoice ? (
                <li
                  onClick={() => {
                    handleOpenUrl(ConsultationDetails?.otherdocuments.Invoice);
                  }}
                >
                  Consultation Invoice
                </li>
              ) : (
                ""
              )}
            </ul>

            <div className="consultation-end">End of Consultation</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationHistoryModalContent;
